import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const VideoBanner = ({ banner }) => {
  const videoType = banner.video.url.split(".").pop();

  if (!["mp4", "webm", "ogg"].includes(videoType)) {
    return null; // Unsupported video format
  }

  return (
    <video
      name="media"
      controls
      autoPlay
      muted
      loop
      className="w-full h-auto object-fill m-auto aspect-video"
    >
      <source
        src={`${settings.cdn}${banner.video.url}`}
        type={`video/${videoType}`}
      />
    </video>
  );
};

export default VideoBanner;
